import { ChangeEvent, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { presignedImageRequest, presignedURLIssue } from '../../../api/admin/api-common-storage';
import { getMyTenantId } from '../../../helpers/h-userInfo';
import { setSelectedChannel } from '../../../redux/slice/counselingManagementSlice';
import NoImageUserAvatar from '../../../assets/image/profile_photo.png';
const CounselingChannelsProfile = () => {
  const { selectedChannel } = useAppSelector((state) => state.counselingManagement);
  const { usersid } = useAppSelector((state) => state.user);
  const [defaultImageSrc, setDefaultImageSrc] = useState(NoImageUserAvatar);

  const dispatch = useAppDispatch();

  const handleFileChange = async (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];

    if (!file) return;

    const issue = await presignedURLIssue({
      sid: usersid ?? '',
      relkey: selectedChannel?.id ?? '',
      tenantid: getMyTenantId()!,
      operation: 'PUT', // 삭제하려면 이거 DELETE 로 주고 응답으로 온 값을 DELETE 요청 날리면됨
      fileid: selectedChannel?.id ?? 'uuid',
    });

    const requestURL = issue.data.data.result[0].presignedurl;

    const imageUrlResponse = await presignedImageRequest(file, requestURL);
    const imageUrl = imageUrlResponse.data.data.result;

    if (selectedChannel) {
      dispatch(
        setSelectedChannel({
          id: selectedChannel.id,
          name: selectedChannel.name,
          description: selectedChannel.description,
          fixed: selectedChannel.fixed,
          sortorder: selectedChannel.sortorder,
          updatetime: selectedChannel.updatetime,
          imagepath: imageUrl,
        }),
      );
    }
  };

  return (
    <div className="relative m-auto w-14 h-14">
      <img
        src={selectedChannel?.imagepath || defaultImageSrc}
        className="w-full h-full rounded-full"
        onError={(e) => {
          const target = e.target as HTMLImageElement;
          target.onerror = null;
          target.src = '';
        }}
      />

      <label
        htmlFor="file-upload"
        className="absolute bottom-0 right-0 mb-0 flex items-center justify-center bg-C-1f62b9 text-white rounded-full w-7 h-7 cursor-pointer hover:bg-blue-500"
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" className="w-5 h-5">
          <path
            fillRule="evenodd"
            d="M12 3a1 1 0 011 1v7h7a1 1 0 110 2h-7v7a1 1 0 11-2 0v-7H4a1 1 0 110-2h7V4a1 1 0 011-1z"
            clipRule="evenodd"
          />
        </svg>
        <input type="file" id="file-upload" className="hidden" accept="image/*" onChange={handleFileChange} />
      </label>
    </div>
  );
};

export default CounselingChannelsProfile;
